<script>
import _ from 'lodash'
import PotentialService from '@/request/patient/potential'
export default {
  name: 'PatientSymptomEdit',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      saving: false,
      editSymptom: {},
      tags: []
    }
  },
  computed: {},
  created: function () {
    this.listTag()
    this.init()
  },
  mounted: function () {},
  beforeDestroy () {},
  watch: {
    value () {
      this.init()
    }
  },
  methods: {
    init () {
      if (_.isEmpty(this.value)) {
        this.editSymptom = {}
        return
      }
      this.editSymptom = _.cloneDeep(this.value)
    },
    listTag () {
      PotentialService.listTag().then(res => {
        this.tags = _.clone(res.result || [])
      })
    },
    handleCancelEditSymptom () {
      this.editSymptom = {}
      this.$emit('close')
    },
    save () {
      let self = this
      let message = this.$message({
        message: '正在保存患者信息...',
        center: true,
        duration: 0
      })
      self.saving = true
      let _symptom = _.cloneDeep(this.editSymptom)
      if (_.isEqual(_symptom, self.value)) {
        self.$message({
          message: '保存病症成功',
          type: 'success'
        })
        message.close()
        self.saving = false
        this.$emit('saveDone', self.value)
        return
      }
      self.$refs['editForm'].validate(valid => {
        if (valid) {
          PotentialService.saveSymptom(_symptom).then(res => {
            let data = res.result || null
            if (!data) {
              self.$message.error('保存病症成功')
              return
            }
            self.$message({
              message: '保存病症成功',
              type: 'success'
            })
            this.$emit('input', data)
            this.$emit('saveDone', data)
          }).catch(error => {
            self.$message.error(error)
            this.$emit('error', error)
          }).finally(() => {
            message.close()
            self.saving = false
          })
        } else {
          self.$message.error('表单验证失败!')
          self.saving = false
        }
      })
    }
  }
}
</script>

<template>
  <el-form ref="editForm" label-position="right" label-width="100px" :model="editSymptom" :disabled="saving">
    <el-form-item label="分类" prop="tag">
      <el-select v-model="editSymptom.tag" clearable placeholder="请选择分类" style="width: 100%;">
        <el-option
          v-for="item in tags"
          :key="item.name"
          :label="item.name"
          :value="item.name">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="部位" prop="position">
      <el-input v-model="editSymptom.position" placeholder="请输入病症部位"></el-input>
    </el-form-item>
    <el-form-item label="主诉" prop="reflect">
      <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="editSymptom.reflect" placeholder="请输入主诉"></el-input>
    </el-form-item>
    <el-form-item label="症状" prop="remark">
      <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="editSymptom.remark" placeholder="请输入症状描述"></el-input>
    </el-form-item>
    <el-form-item>
      <symptom-image-list :sourceId="editSymptom.id" :mark="editSymptom.oname"></symptom-image-list>
    </el-form-item>
    <el-form-item v-if="showButtons">
      <el-button @click="handleCancelEditSymptom">取消</el-button>
      <el-button type="primary" @click="save()">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
